import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const H2 = ({ children, num }) => (
  <h2 className="text-2xl font-heading font-bold text-spin-dark mt-10 mb-3">
    {num}. {children}
  </h2>
);

const H3 = ({ children }) => (
  <h3 className="text-lg font-heading font-semibold text-spin-dark mt-6 mb-2">{children}</h3>
);

const P = ({ children }) => (
  <p className="leading-relaxed mb-3 text-spin-grey">{children}</p>
);

const A = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-spin-green hover:underline break-words"
  >
    {children}
  </a>
);

export default function Datenschutz() {
  return (
    <>
      <Header />
      <main className="pt-28 pb-20 bg-white">
        <div className="max-w-3xl mx-auto px-5">
          <h1 className="text-4xl font-heading font-extrabold text-spin-dark mb-2">
            Datenschutzerklärung
          </h1>
          <hr className="section-divider" style={{ marginLeft: 0 }} />

          <div className="text-base">
            <P>Verantwortlicher für die Datenverarbeitung ist:</P>
            <p className="leading-relaxed mb-6 text-spin-dark font-medium">
              Drita Schneider<br />
              Hasberger Str. 9C<br />
              87757 Kirchheim<br />
              +49 8266 8612-12<br />
              <a href="mailto:info@spinsafe.de" className="text-spin-green hover:underline">
                info@spinsafe.de
              </a>
            </p>

            <P>
              Wir freuen uns über Ihr Interesse an unserem Online-Auftritt. Der Schutz Ihrer
              Privatsphäre ist für uns sehr wichtig. Nachstehend informieren wir Sie ausführlich
              über den Umgang mit Ihren Daten.
            </P>

            <H2 num="1">Zugriffsdaten und Hosting</H2>
            <P>
              Sie können unsere Webseiten besuchen, ohne Angaben zu Ihrer Person zu machen. Bei
              jedem Aufruf einer Webseite speichert der Webserver lediglich automatisch ein
              sogenanntes Server-Logfile, das z. B. den Namen der angeforderten Datei, Ihre
              IP-Adresse, Datum und Uhrzeit des Abrufs, übertragene Datenmenge und den anfragenden
              Provider (Zugriffsdaten) enthält und den Abruf dokumentiert.
            </P>
            <P>
              Diese Zugriffsdaten werden ausschließlich zum Zwecke der Sicherstellung eines
              störungsfreien Betriebs der Seite sowie der Verbesserung unseres Angebots
              ausgewertet. Dies dient gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO der Wahrung unserer im
              Rahmen einer Interessensabwägung überwiegenden berechtigten Interessen an einer
              korrekten Darstellung unseres Angebots. Alle Zugriffsdaten werden spätestens sieben
              Tage nach Ende Ihres Seitenbesuchs gelöscht.
            </P>

            <H3>Hostingdienstleistungen durch einen Drittanbieter</H3>
            <P>
              Im Rahmen einer Verarbeitung in unserem Auftrag erbringt ein Drittanbieter für uns
              die Dienste zum Hosting und zur Darstellung der Webseite. Dies dient der Wahrung
              unserer im Rahmen einer Interessensabwägung überwiegenden berechtigten Interessen an
              einer korrekten Darstellung unseres Angebots. Alle Daten, die im Rahmen der Nutzung
              dieser Webseite oder in dafür vorgesehenen Formularen wie folgend beschrieben
              erhoben werden, werden auf seinen Servern verarbeitet. Eine Verarbeitung auf anderen
              Servern findet nur in dem hier erläuterten Rahmen statt.
            </P>
            <P>
              Dieser Dienstleister sitzt innerhalb eines Landes der Europäischen Union oder des
              Europäischen Wirtschaftsraums.
            </P>

            <H2 num="2">Datenerhebung bei Kontaktaufnahme</H2>
            <P>
              Wir erheben personenbezogene Daten, wenn Sie uns diese im Rahmen einer
              Kontaktaufnahme mit uns (z. B. per Kontaktformular, Newsletter-Anmeldung oder
              E-Mail) freiwillig mitteilen. Pflichtfelder werden als solche gekennzeichnet, da
              wir in diesen Fällen die Daten zwingend zur Bearbeitung Ihrer Kontaktaufnahme
              benötigen und Sie ohne deren Angabe die Kontaktaufnahme nicht versenden können.
              Welche Daten erhoben werden, ist aus den jeweiligen Eingabeformularen ersichtlich.
              Wir verwenden die von Ihnen mitgeteilten Daten gemäß Art. 6 Abs. 1 S. 1 lit. b
              DSGVO zur Bearbeitung Ihrer Anfragen. Nach vollständiger Bearbeitung Ihrer Anfrage
              werden Ihre Daten für die weitere Verarbeitung eingeschränkt und nach Ablauf
              etwaiger gesetzlicher Aufbewahrungsfristen gelöscht, sofern Sie nicht ausdrücklich
              in eine weitere Nutzung Ihrer Daten eingewilligt haben.
            </P>

            <H2 num="3">Datenweitergabe</H2>
            <P>
              Eine Weitergabe Ihrer personenbezogenen Daten an Dritte findet nicht statt,
              außer wir sind dazu gesetzlich verpflichtet oder Sie haben ausdrücklich in die
              Datenweitergabe eingewilligt. Zur Zustellung der E-Mail-Benachrichtigungen aus
              Formularen dieser Webseite (Kontakt, Newsletter-Anmeldung) setzen wir unseren
              Mailhosting-Dienstleister mit Sitz in Deutschland ein.
            </P>

            <H2 num="4">E-Mail-Newsletter</H2>
            <H3>E-Mail-Werbung mit Anmeldung zum Newsletter</H3>
            <P>
              Wenn Sie sich zu unserem Newsletter anmelden, verwenden wir die hierfür
              erforderlichen oder gesondert von Ihnen mitgeteilten Daten, um Ihnen regelmäßig
              unseren E-Mail-Newsletter aufgrund Ihrer Einwilligung gemäß Art. 6 Abs. 1 S. 1 lit. a
              DSGVO zuzusenden.
            </P>
            <P>
              Die Abmeldung vom Newsletter ist jederzeit möglich und kann entweder durch eine
              Nachricht an die unten beschriebene Kontaktmöglichkeit oder über einen dafür
              vorgesehenen Link im Newsletter erfolgen. Nach Abmeldung löschen wir Ihre
              E-Mail-Adresse, soweit Sie nicht ausdrücklich in eine weitere Nutzung Ihrer Daten
              eingewilligt haben oder wir uns eine darüber hinausgehende Datenverwendung
              vorbehalten, die gesetzlich erlaubt ist und über die wir Sie in dieser Erklärung
              informieren.
            </P>
            <P>
              Der Newsletter wird im Rahmen einer Verarbeitung in unserem Auftrag durch einen
              Dienstleister versendet, an den wir Ihre E-Mail-Adresse hierzu weitergeben. Dieser
              Dienstleister sitzt innerhalb eines Landes der Europäischen Union oder des
              Europäischen Wirtschaftsraums.
            </P>

            <H2 num="5">Cookies und Webanalyse</H2>
            <P>
              Um den Besuch unserer Website attraktiv zu gestalten und die Nutzung bestimmter
              Funktionen zu ermöglichen, verwenden wir auf verschiedenen Seiten sogenannte Cookies. Dies dient der Wahrung
              unserer im Rahmen einer Interessensabwägung überwiegenden berechtigten Interessen an
              einer optimierten Darstellung unseres Angebots gemäß Art. 6 Abs. 1 S. 1 lit. f
              DSGVO. Cookies sind kleine Textdateien, die automatisch auf Ihrem Endgerät
              gespeichert werden. Einige der von uns verwendeten Cookies werden nach Ende der
              Browser-Sitzung, also nach Schließen Ihres Browsers, wieder gelöscht (sog.
              Sitzungs-Cookies). Andere Cookies verbleiben auf Ihrem Endgerät und ermöglichen uns,
              Ihren Browser beim nächsten Besuch wiederzuerkennen (persistente Cookies). Die Dauer
              der Speicherung können Sie der Übersicht in den Cookie-Einstellungen Ihres
              Webbrowsers entnehmen. Sie können Ihren Browser so einstellen, dass Sie über das
              Setzen von Cookies informiert werden und einzeln über deren Annahme entscheiden oder
              die Annahme von Cookies für bestimmte Fälle oder generell ausschließen. Jeder
              Browser unterscheidet sich in der Art, wie er die Cookie-Einstellungen verwaltet.
              Diese ist in dem Hilfemenü jedes Browsers beschrieben, welches Ihnen erläutert, wie
              Sie Ihre Cookie-Einstellungen ändern können. Diese finden Sie für die jeweiligen
              Browser unter den folgenden Links:
            </P>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-spin-grey">
              <li>
                Internet Explorer™:{' '}
                <A href="https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies">
                  Anleitung
                </A>
              </li>
              <li>
                Safari™:{' '}
                <A href="https://support.apple.com/de-de/guide/safari/sfri11471/mac">Anleitung</A>
              </li>
              <li>
                Chrome™:{' '}
                <A href="https://support.google.com/chrome/answer/95647?hl=de">Anleitung</A>
              </li>
              <li>
                Firefox™:{' '}
                <A href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen">
                  Anleitung
                </A>
              </li>
              <li>
                Opera™:{' '}
                <A href="https://help.opera.com/de/latest/web-preferences/#cookies">
                  Anleitung
                </A>
              </li>
            </ul>
            <P>Bei der Nichtannahme von Cookies kann die Funktionalität unserer Website eingeschränkt sein.</P>

            <P>
              Für die Nutzung dieser Website werden aktuell{" "}
              <strong>keine Web-Analyse-Werkzeuge</strong> (wie z. B. Google Analytics oder
              Matomo) und <strong>keine Marketing-Cookies</strong> eingesetzt. Es findet somit
              keine Nachverfolgung Ihres Nutzungsverhaltens statt. Sollten wir zukünftig solche
              Dienste einsetzen, werden wir diese Datenschutzerklärung entsprechend aktualisieren
              und Ihre Einwilligung einholen, soweit erforderlich.
            </P>

            <H2 num="6">Online-Präsenz auf sozialen Netzwerken</H2>
            <H3>Unsere Onlinepräsenz auf Facebook, Google, Instagram</H3>
            <P>
              Unsere Präsenz auf sozialen Netzwerken und Plattformen dient einer besseren, aktiven
              Kommunikation mit unseren Kunden und Interessenten. Wir informieren dort über unsere
              Produkte und laufende Sonderaktionen. Bei dem Besuch unserer Onlinepräsenzen in
              sozialen Medien können Ihre Daten für Marktforschungs- und Werbezwecke automatisch
              erhoben und gespeichert werden. Aus diesen Daten werden unter Verwendung von
              Pseudonymen sog. Nutzungsprofile erstellt. Diese können verwendet werden, um z. B.
              Werbeanzeigen innerhalb und außerhalb der Plattformen zu schalten, die mutmaßlich
              Ihren Interessen entsprechen. Zu diesem Zweck werden im Regelfall Cookies auf Ihrem
              Endgerät eingesetzt. In diesen Cookies werden das Besucherverhalten und die
              Interessen der Nutzer gespeichert.
            </P>
            <P>
              Die detaillierten Informationen zur Verarbeitung und Nutzung der Daten durch die
              Anbieter auf deren Seiten sowie eine Kontaktmöglichkeit und Ihre diesbezüglichen
              Rechte und Einstellungsmöglichkeiten zum Schutz Ihrer Privatsphäre, insbesondere
              Widerspruchsmöglichkeiten (Opt-Out), entnehmen Sie bitte den nachfolgend verlinkten
              Datenschutzhinweisen der Anbieter:
            </P>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-spin-grey">
              <li>
                Facebook: <A href="https://www.facebook.com/about/privacy/">Datenschutzhinweise</A>
              </li>
              <li>
                Vereinbarung zwischen gemeinsam Verantwortlichen (Art. 26 DSGVO):{' '}
                <A href="https://www.facebook.com/legal/terms/page_controller_addendum">
                  Page Controller Addendum
                </A>
              </li>
              <li>
                Google / YouTube:{' '}
                <A href="https://policies.google.com/privacy">Datenschutzhinweise</A>
              </li>
              <li>
                Instagram:{' '}
                <A href="https://help.instagram.com/519522125107875">Datenschutzhinweise</A>
              </li>
            </ul>
            <P>Widerspruchsmöglichkeit (Opt-Out):</P>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-spin-grey">
              <li>
                Facebook: <A href="https://www.facebook.com/settings?tab=ads">Einstellungen</A>
              </li>
              <li>
                Google / YouTube:{' '}
                <A href="https://adssettings.google.com/authenticated">Anzeigeneinstellungen</A>
              </li>
              <li>
                Instagram:{' '}
                <A href="https://help.instagram.com/519522125107875">Hilfeseite</A>
              </li>
            </ul>

            <H2 num="7">Kontaktmöglichkeiten und Ihre Rechte</H2>
            <P>Als Betroffener haben Sie folgende Rechte:</P>
            <ul className="list-disc pl-6 mb-4 space-y-2 text-spin-grey">
              <li>
                gemäß Art. 15 DSGVO das Recht, in dem dort bezeichneten Umfang Auskunft über Ihre
                von uns verarbeiteten personenbezogenen Daten zu verlangen;
              </li>
              <li>
                gemäß Art. 16 DSGVO das Recht, unverzüglich die Berichtigung unrichtiger oder
                Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu
                verlangen;
              </li>
              <li>
                gemäß Art. 17 DSGVO das Recht, die Löschung Ihrer bei uns gespeicherten
                personenbezogenen Daten zu verlangen, soweit nicht die weitere Verarbeitung zur
                Ausübung des Rechts auf freie Meinungsäußerung und Information, zur Erfüllung
                einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur
                Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;
              </li>
              <li>
                gemäß Art. 18 DSGVO das Recht, die Einschränkung der Verarbeitung Ihrer
                personenbezogenen Daten zu verlangen;
              </li>
              <li>
                gemäß Art. 20 DSGVO das Recht, Ihre personenbezogenen Daten, die Sie uns
                bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren
                Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu
                verlangen;
              </li>
              <li>
                gemäß Art. 77 DSGVO das Recht, sich bei einer Aufsichtsbehörde zu beschweren. In
                der Regel können Sie sich hierfür an die Aufsichtsbehörde Ihres üblichen
                Aufenthaltsortes oder Arbeitsplatzes oder unseres Unternehmenssitzes wenden.
              </li>
            </ul>
            <P>
              Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten,
              bei Auskünften, Berichtigung, Einschränkung oder Löschung von Daten sowie Widerruf
              erteilter Einwilligungen oder Widerspruch gegen eine bestimmte Datenverwendung
              wenden Sie sich bitte direkt an uns über die Kontaktdaten in unserem Impressum.
            </P>

            <H3>Widerspruchsrecht</H3>
            <P>
              Soweit wir zur Wahrung unserer im Rahmen einer Interessensabwägung überwiegenden
              berechtigten Interessen personenbezogene Daten wie oben erläutert verarbeiten,
              können Sie dieser Verarbeitung mit Wirkung für die Zukunft widersprechen. Erfolgt
              die Verarbeitung zu Zwecken des Direktmarketings, können Sie dieses Recht jederzeit
              wie oben beschrieben ausüben. Soweit die Verarbeitung zu anderen Zwecken erfolgt,
              steht Ihnen ein Widerspruchsrecht nur bei Vorliegen von Gründen, die sich aus Ihrer
              besonderen Situation ergeben, zu.
            </P>
            <P>
              Nach Ausübung Ihres Widerspruchsrechts werden wir Ihre personenbezogenen Daten nicht
              weiter zu diesen Zwecken verarbeiten, es sei denn, wir können zwingende
              schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte
              und Freiheiten überwiegen, oder wenn die Verarbeitung der Geltendmachung, Ausübung
              oder Verteidigung von Rechtsansprüchen dient. Dies gilt nicht, wenn die Verarbeitung
              zu Zwecken des Direktmarketings erfolgt. Dann werden wir Ihre personenbezogenen
              Daten nicht weiter zu diesem Zweck verarbeiten.
            </P>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
